export default "__VITE_ASSET__E24ZRO10__"